// extracted by mini-css-extract-plugin
export default {"side_dashes":"FormButton_side_dashes__1aKw6","side_dashes_span":"FormButton_side_dashes_span__V-k+u"};